module.exports = __webpack_public_path__ + "img/logo@2x.04b01f0b.png";